import {
  useApolloRequestLazyWrapper,
  type LazyResponse,
} from '../../../api/useApolloRequestLazyWrapper'
import {
  type GetRetailerProductsQuery,
  type GetRetailerProductsQueryVariables,
  useGetRetailerProductsLazyQuery,
} from '../../../../api'
import { type GetRetailerProductsResponse } from './types'

function mapResponse(data: GetRetailerProductsQuery): GetRetailerProductsResponse {
  if (!data?.retailerToolsServiceGetRetailerProducts?.results?.length) {
    return { products: [], totalCount: 0 }
  }

  const products = data.retailerToolsServiceGetRetailerProducts.results.filter(Boolean)
  const totalCount = data.retailerToolsServiceGetRetailerProducts.totalCount
    ? parseInt(data.retailerToolsServiceGetRetailerProducts.totalCount, 10)
    : 0

  return { products, totalCount }
}

export const useGetRetailerProducts = (): LazyResponse<
  GetRetailerProductsResponse,
  GetRetailerProductsQueryVariables
> => {
  const resultTuple = useGetRetailerProductsLazyQuery({
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  })

  return useApolloRequestLazyWrapper({
    resultTuple,
    mapResponse,
  })
}
